import { Exclude, Expose } from 'class-transformer';
import { JobInteriorExteriorOptionsHistoryInterface } from '../interfaces/job-interior-exterior-options-history.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import {
  IsBoolean,
  IsDate,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { JobDto } from '../../job/dto/job.dto';
import { UserDto } from '../../user/dto/user.dto';
import { JobPhaseDto } from '../../job-phase/dto/job-phase.dto';

@Exclude()
export class JobInteriorExteriorOptionsHistoryDto
  extends CommonEntityDto
  implements JobInteriorExteriorOptionsHistoryInterface
{
  @ApiProperty({
    type: 'string',
    title: 'Job Phase ID',
    description: 'Job Phase ID',
  })
  @IsString()
  @Expose()
  jobPhaseId!: string;

  @ApiPropertyOptional({
    type: () => JobPhaseDto,
    title: 'JobPhaseDTO',
    description: 'Job Phase associated with this option history',
  })
  @Expose()
  jobPhase?: JobPhaseDto | undefined;

  @ApiProperty({
    type: 'string',
    title: 'Type Option',
    description: 'Defines the option type',
  })
  @IsString()
  @Expose()
  typeOption!: string;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated User ID',
  })
  @IsUUID()
  @Expose()
  userId!: string;

  @ApiProperty({
    type: 'boolean',
    title: 'Check',
    description: 'Indicates whether the option is checked',
  })
  @IsBoolean()
  @Expose()
  check!: boolean;

  @ApiPropertyOptional({
    type: 'string',
    format: 'date-time',
    title: 'Date',
    description: 'Date when the option was updated',
    nullable: true,
  })
  @IsDate()
  @IsOptional()
  @Expose()
  date!: Date | null;

  @ApiPropertyOptional({
    type: () => UserDto,
    title: 'User',
    description: 'User associated with this option history',
  })
  @Expose()
  user?: UserDto;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job ID',
  })
  @IsUUID()
  @Expose()
  jobId!: string;

  @ApiPropertyOptional({
    type: () => JobDto,
    title: 'Job',
    description: 'Job associated with this option history',
  })
  @Expose()
  job?: JobDto;
}
